export var styleVariables = {
    colors: {
        primaryColor: '#03A9F4',
        greenColorPrimary: '#66CC33',
        redColorPrimary: '#AB1919',
        timelineActiveColor: '#ff9900'
    }
};
